<ul>
  <li>
    <p>
      <span
        ><span style="color: #00b0f0;"><span><span lang="en-GB"><strong>Target</strong></span></span></span><span style="color: #00b0f0;"
          ><span><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >If YTD is selected: Target for Bolus churn rate p.m. for the current year (= target for annual Bolus churn rate / 12). Else:
              Target for Bolus churn rate p.a. in the year of the selected timeframe.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span
        ><span style="color: #404040;"><span><span lang="en-GB"><strong>Actual</strong></span></span></span><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >: If YTD is selected: Actual average Bolus churn rate p.m. (based on all months YTD) or Bolus churn rate p.a.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">: The icon indicates whether the target is met (</span></span></span><span
          style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">) or missed (</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">)</span></span></span></span
      >
    </p>
  </li>
</ul>
<p lang="en-GB">&nbsp;</p>
<p>
  <span
    ><span style="color: #7f7f7f;"
      ><span><span lang="en-GB"><em><span style="text-decoration: underline;">Calculation of the Bolus churn rate</span></em></span></span
      ></span
    ><span style="color: #7f7f7f;"
      ><span
        ><span lang="en-GB"
          ><em
            >: Total number of active boluses of "churn" customers (customers, that cancelled their subscription within a specific period
            e.g. one month) / Total number of active boluses at the beginning of the same period e.g. one month.</em
          ></span
        ></span
      ></span
    ></span
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p><span><span style="color: #404040;"><span><span lang="en-GB">Chart Bolus Churn rate:</span></span></span></span></p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAICAYAAABte3YfAAAAr0lEQVR4nNWSMQ7CMAxFndZhIS3X4DgsLByQhYXjcAAEM21YsBODK0WtuoGiVPzJX+9L/w9GEYGcYgHsWZrkPYujCFbvAFB3JG1izyDrV4TVwOTDeMJ4ZBGgepBsEsPznXbHKx3UaJmW6q1FPohLwSnjOBsWxmElhBcft6cb7UsV5hAuPeAXoQHI+9QFhK013dIjvtV/vkfpQlsBudr45Bs0PVbAwxgDrD4xzWl+zt4sZFSMsyec0AAAAABJRU5ErkJggg=="
            alt=""
          />&nbsp; &nbsp; Target for bolus churn rate p.q. (=annual target/4) or per half-year (=annual target/2)</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            style="height:12px;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGNxjQ/8z4AHsOCTHFVAggIA4psCIYbRm1MAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Total of monthly churn rates in quarter/half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAHCAYAAABtJp9HAAAAcUlEQVR4nGO5cP2yw5nL5z0YsAAfR/cZ4iJiD9DFf/3+zbF4w4oGbHpkJaVvuNk4LcAmd+zcyYDrd29ZYJNjAUms3Lq+HJukub7JFmwO+f3nNztuPcZbcTnk7JWLbpv37cjE6hBsggMBRh2CDkYdgg4A+skqv1R38JsAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Average bolus churn rate p.q./per half-year in selected year</span
        ></span
      ></span
    ></span
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            style="height:12px;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Total of monthly churn rates in quarter/half-year of prev. year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAHCAYAAABkzT89AAAAm0lEQVR4nGP5+PGjxYcPH+wZsAAREZH1XFxct7DJPXv2LPPPnz98yGKMjIz/WFlZX0tISCzApufHjx9y796988Amx8PDc4GPj+8UjM8CdJTDvXv32rEp5ubmvoLLYQ8fPqz4+fOnHLo4CwvLR1wO+/r1q+6tW7dmYpOTk5PrQHEYNkWDAYwchwHT2W9qmEN1hzExMX2jhjmDNioBSL8zRBx0t2QAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Average bolus churn rate p.q./per half-year in previous year</span
        ></span
      ></span
    ></span
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p>
  <span
    ><span style="color: #404040;"><span><span lang="en-GB">Chart Herd Churn rate</span></span></span><span style="color: #404040;"
      ><span><span lang="en-GB">:</span></span></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            style="height:12px;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGP5f4DhPwMewIJPclQBCQoAAJ4C644aR9AAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Total of monthly Herd churn rates per quarter/half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAHCAYAAABOfc6SAAAAzklEQVR4nGP5//O5BMPPp9IM2ACX+k0GZp4vWOXe73HBEPv3jYuBmfczg4Djfqx6vt3QYPh6WZfhz0d+oGImFDkhjx0M7HKPsOp73F2KoR4E2GWesDC8WJDAcL+yHatGg8O2DPw2R7DKXXLdjVUcpB6kDxt4syEAp126W3xweuBRazXE05h2sWDVAAOgEB3M4O83Lvwe+P+bFaccI/Nfhv9/mantJpIA0H34PYAPgPIGtmj9/4d8M8kA1Lfs71duqpuJB9A1tBiYub9S20gA4NRB/oNaX3IAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Average herd churn rate p.q./per half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>&nbsp;</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            style="height:12px;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Total of monthly Herd churn rates per quarter/half-year previous year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAHCAYAAACcLcTKAAAAvElEQVR4nGP5/PmzwadPn8z+///P/vfvXy4GJCAqKrqGk5PzLgMW8OTJk4J///6xo4uzsLB8kpKSmo5Nz9evX7Xevn3ri01OQEDgIB8f3wlsci9fvoz++fOnDNyOd+/eedy7d68dm2Jubu4ruBz94MGDhj9//vCji7Ozsz/C5egvX74YAO3qwCanpKRUicvRz549y/j48aMN3NHYFBEDGBkZf5Grl1JAtqOZmJi+U9MhpACyHT2QYNTR9AIAuWREeP0bNvAAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Average herd churn rate per quarter/half-year prev. year</span
        ></span
      ></span
    ></span
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p style="margin-bottom: 10px;">
  <span
    ><span style="color: #7f7f7f;"
      ><span><span lang="en-GB"><em><span style="text-decoration: underline;">Calculation of Herd churn rate</span></em></span></span></span
    ><span style="color: #7f7f7f;"
      ><span
        ><span lang="en-GB"
          ><em
            >: Total number of MaxInstallations of "churn" customers (customers, that cancelled their subscription within a specific period,
            e.g. one month) in the month of the cancellation / Total number of active boluses at the beginning of the month.</em
          ></span
        ></span
      ></span
    ></span
  >
</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }

  img {
    width: 11px;
    height: 2px;
  }
</style>
